import script from "./ActivityScoresPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./ActivityScoresPanel.vue?vue&type=script&setup=true&lang=js"

import "./ActivityScoresPanel.vue?vue&type=style&index=0&id=5521d08c&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5521d08c"]])

export default __exports__